export const isFactuFlowSaas = process.env.REACT_APP_FACTUFLOW_SAAS === "true";

export const isAvailableInDeployment = (item) =>
  !isFactuFlowSaas || (item?.group !== "aiDevelopment" && item?.key !== "businessRules");
